import React from "react";
import { Link } from "react-router-dom";
import { useAuth, hasPermission } from "../context/AuthContext";
import { Pill } from "./Ui";

/**
 * Stock purchase contract → stack sample intake (when user may view that page).
 */
export default function PurchaseContractSampleLink({ contract, className }) {
  const { user } = useAuth();
  const canViewSamples = hasPermission(user, "page.stack_samples");

  if (contract?.contract_phase !== "PRE_ARRIVAL" || contract?.purchase_type !== "STOCK_PURCHASE") {
    return <span className={className}>—</span>;
  }

  const partyQuery = contract.party_id ? `?party_id=${contract.party_id}` : "";
  const intakeTo = `/stack-sample-intake${partyQuery}`;

  if (contract.supervisor_todo_status === "PENDING") {
    if (canViewSamples) {
      return (
        <Link
          to={intakeTo}
          className={`text-primary hover:text-primary underline underline-offset-2 font-medium ${className || ""}`}
          data-testid={`pac-sample-link-${contract.id}`}
        >
          Register sample →
        </Link>
      );
    }
    return (
      <span className={className}>
        <Pill tone="gold">Supervisor TODO</Pill>
      </span>
    );
  }

  if (contract.linked_lab_report) {
    const lab = contract.linked_lab_report;
    const label = `${lab.intake_code || "Sample"} · ${(lab.verdict || "").replace(/_/g, " ")}`;
    if (canViewSamples) {
      return (
        <Link
          to={intakeTo}
          className={`text-primary hover:text-primary underline underline-offset-2 ${className || ""}`}
          data-testid={`pac-sample-link-${contract.id}`}
          title="View in stack sample registry"
        >
          {label}
        </Link>
      );
    }
    return <span className={className}>{label}</span>;
  }

  if (contract.stock_sample_analysed === false || contract.stock_sample_analysed === null) {
    if (canViewSamples) {
      return (
        <Link
          to={intakeTo}
          className={`text-xs text-muted-foreground hover:text-primary underline underline-offset-2 ${className || ""}`}
        >
          View samples
        </Link>
      );
    }
  }

  return <span className={className}>—</span>;
}
